function initAccordion() {

    $(document).on('click', '.accordion__label', function (e) {
      const $item = $(this).closest('.accordion__item');
      const $content = $item.find('.accordion__content');
      const isActive = $item.hasClass('active');
  
      /**
       * FAQ accordion close edge-case
       */
      $(this)
        .closest('.faq-main__accordion')
        .find('.accordion__item.active')
        .removeClass('active')
        .find('.accordion__content')
        .not($content)
        .slideUp();
  
      if (
        ($item.closest('.modal-block').length == 1 && window.innerWidth > 768) ||
        $item.closest('.modal-block').length == 0
      ) {
        $(this)
          .closest('.accordion')
          .find('.accordion__item.active')
          .removeClass('active')
          .find('.accordion__content')
          .not($content)
          .slideUp();
      }
  
      if (isActive) {
        $content.slideUp();
        $item.removeClass('active');
      } else {
        $content.slideDown();
        $item.addClass('active');
      }
    });
  }
  initAccordion();